import React from 'react'
import {ReactComponent as Logo} from "./Logo.svg";
import {ReactComponent as LogoWhite} from "./Logo_white.svg";

export default {Logo, LogoWhite}
